import React, { ButtonHTMLAttributes, FC } from 'react';
import PropTypes from 'prop-types';
import { type } from 'os';

// const Button: FC<Button> = (props: Button): JSX.Element => (
//     <button
//         onClick={props.onClick}
//         style={props.styles}
//         disabled={props.disabled}
//         type={props.type}
//         className={
//             'bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded ' +
//             props.className
//         }
//     >
//         {props.children}
//     </button>
// );

const Button = ({ 
    children,
    onClick,
    styles, 
    disabled
}) => {
    return (
        <>
            <button
                onClick={onClick}
                style = {styles}
                disabled = {disabled}
                type = 'button'
                className='bg-blue-500 hover:bg-blue-400 text-white font-bold my-5 py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded '
            >
                {children}
            </button>
        </>
    );
};

Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onClick: PropTypes.func.isRequired,
    styles: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
};

Button.defaultProps = {
    children: null,
    onClick: (): void => {},
    styles: {},
    disabled: false,
    type: 'button',
};

export default Button;
